import { render } from "./AjustesView.vue?vue&type=template&id=0a944fcc"
import script from "./AjustesView.vue?vue&type=script&lang=js"
export * from "./AjustesView.vue?vue&type=script&lang=js"

import "./AjustesView.vue?vue&type=style&index=0&id=0a944fcc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__